var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import create from 'zustand';
import useCancerConfig from '../config/useCancerConfig';
import useConfig from '../config/useConfig';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var useConfigurationStore = create(function (set, get) { return ({
    cancer: undefined,
    behavior: undefined,
    ethnicities: undefined,
    race: undefined,
    setting: undefined,
    menopausal: undefined,
    recurrence: undefined,
    recurrence_areas: undefined,
    areas_of_metastasis: undefined,
    sex: undefined,
    event_history_status: undefined,
    panel_type: undefined,
    treatment_history_status: undefined,
    setConfig: function (key, config) {
        set(function (previous) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[key] = config, _a)));
        });
    },
}); });
export function useQueryAndStoreConfig(store, key, enable) {
    var _a = useConfig(key, {
        onSuccess: function (data) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            store[key] === undefined && store.setConfig(key, data);
        },
        enabled: store[key] === undefined && enable,
    }), isLoading = _a.isLoading, isFetching = _a.isFetching;
    return {
        isLoading: isLoading || isFetching,
    };
}
export function useQueryAndStoreCancerConfig(store, enable) {
    var _a = useCancerConfig({
        onSuccess: function (data) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            store.cancer === undefined && store.setConfig('cancer', data);
        },
        enabled: store.cancer === undefined && enable,
    }), isLoading = _a.isLoading, isFetching = _a.isFetching;
    return {
        isLoading: isLoading || isFetching,
    };
}
export function useConfigs(keys) {
    var store = useConfigurationStore();
    var isCancerLoading = useQueryAndStoreCancerConfig(store, keys.some(function (x) { return x === 'cancer'; })).isLoading;
    var isBehaviorLoading = useQueryAndStoreConfig(store, 'behavior', keys.some(function (x) { return x === 'behavior'; })).isLoading;
    var isEthnicitiesLoading = useQueryAndStoreConfig(store, 'ethnicities', keys.some(function (x) { return x === 'ethnicities'; })).isLoading;
    var isRaceLoading = useQueryAndStoreConfig(store, 'race', keys.some(function (x) { return x === 'race'; })).isLoading;
    var isSettingLoading = useQueryAndStoreConfig(store, 'setting', keys.some(function (x) { return x === 'setting'; })).isLoading;
    var isMenopausalLoading = useQueryAndStoreConfig(store, 'menopausal', keys.some(function (x) { return x === 'menopausal'; })).isLoading;
    var isRecurrenceLoading = useQueryAndStoreConfig(store, 'recurrence', keys.some(function (x) { return x === 'recurrence'; })).isLoading;
    var isRecurrenceAreasLoading = useQueryAndStoreConfig(store, 'recurrence_areas', keys.some(function (x) { return x === 'recurrence_areas'; })).isLoading;
    var isMetastasisAreasLoading = useQueryAndStoreConfig(store, 'areas_of_metastasis', keys.some(function (x) { return x === 'areas_of_metastasis'; })).isLoading;
    var isSexLoading = useQueryAndStoreConfig(store, 'sex', keys.some(function (x) { return x === 'sex'; })).isLoading;
    var isEventHistoryStatusLoading = useQueryAndStoreConfig(store, 'event_history_status', keys.some(function (x) { return x === 'event_history_status'; })).isLoading;
    var isPanelTypeLoading = useQueryAndStoreConfig(store, 'panel_type', keys.some(function (x) { return x === 'panel_type'; })).isLoading;
    var isTreatmentHistoryStatusLoading = useQueryAndStoreConfig(store, 'treatment_history_status', keys.some(function (x) { return x === 'treatment_history_status'; })).isLoading;
    var isLoading = isCancerLoading ||
        isBehaviorLoading ||
        isEthnicitiesLoading ||
        isRaceLoading ||
        isSettingLoading ||
        isMenopausalLoading ||
        isRecurrenceLoading ||
        isRecurrenceAreasLoading ||
        isMetastasisAreasLoading ||
        isSexLoading ||
        isEventHistoryStatusLoading ||
        isPanelTypeLoading ||
        isTreatmentHistoryStatusLoading;
    return React.useMemo(function () {
        if (isLoading) {
            return null;
        }
        var results = {};
        return Object.assign(results, Object.fromEntries(keys.map(function (key) { return [key, store[key]]; })));
    }, __spreadArray([isLoading], keys.map(function (key) { return store[key]; }), true));
}
